import React, { FC } from "react";
import styled from "styled-components";
import { ItemCustomizationsProps } from "../common/types";

const Wrapper = styled.div`
  color: #666;
  font-size: 14px;
  padding-top: 10px;
`;

// currently only need to support description, number, text
// will need to be refactored once we know future customizations
export const ItemCustomizations: FC<ItemCustomizationsProps> = ({
  customizations,
}) => {
  const { description, number, text } = customizations?.[0] || {};
  const personalizationText =
    !!number && !!text ? `${text}, ${number}` : `${text || number || ""}`;

  return (
    <Wrapper>
      {!!description && <div>ID Ring: {description}</div>}
      {!!personalizationText && (
        <div>Personalization: {personalizationText}</div>
      )}
    </Wrapper>
  );
};
